import React, { useEffect } from 'react'
import { Table, Tooltip } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { useDictModel } from '@/views/base/dict/dictModel'
import { formatNum, momentFormat } from '@/utils/utils'
import { ISCMAssetsGetDetail } from '../assetsGetTypes'
import { useAssetsGetModel } from '../assetsGetModel'
import { globalPrompt } from '@/components/message'
import useNavModel from '@/model/navModel'
import { useAssetsGetDetailsModel } from './details/assetsGetDetailsModel'
import { DictCodeEnmu } from '@/types/AppDictEnums'
import { useOrgModel } from '@/views/base/organization/orgModel'

export function DataTable() {
    const { getTreeNodeName } = useDictModel(() => [])
    const { getSelectedDictOne } = useDictModel(() => [])
    const { dataSource, selectedRowKeys, pgCfg, loading, loadData, setSelectedRowKeys } = useAssetsGetModel()
    const { resetEditCatch } = useAssetsGetDetailsModel()
    const { addNav, findNav, selectNav, switchNavState } = useNavModel(() => [])
    const { getOrgTreeSelect } = useOrgModel(() => [])

    useEffect(() => {
        loadData()
    }, [])
    const onLook = (value) => {
        let supplierEditKey = '2-2-2'
        let isFindNav = findNav(supplierEditKey)
        if (!isFindNav) {
            addNav(supplierEditKey, { id: value.id, mode: 'look' })
        } else {
            globalPrompt('modal', {
                title: '供应商跳转详情',
                type: 'warning',
                text: '您还有供应商详情未保存，是否跳转',
                okText: '跳转未保存页',
                onOk: () => selectNav(isFindNav ? isFindNav.id : ''),
                cancelText: '打开新页签',
                onCancel: () => {
                    switchNavState(supplierEditKey, { id: value.id, mode: 'look' })
                },
            })
        }
    }
    const columns: ColumnsType<ISCMAssetsGetDetail> = [
        {
            title: '序号',
            width: 50,
            align: 'center',
            fixed: 'left',
            render: (t, r, i) => i + 1,
        },
        {
            title: '领取单号',
            width: 240,
            dataIndex: 'code',
            fixed: 'left',
            render: (t, r) => (
                <>
                    <span
                        style={{ color: '#4165E3', cursor: 'pointer' }}
                        onClick={() => {
                            onLook(r)
                        }}
                    >
                        {t}
                    </span>
                    {r.details.find((item) => item.isReturn == 1) && <span
                        style={{
                            display: 'inline-block',
                            width: '24px',
                            height: '24px',
                            background: 'rgba(246,129,8,.1)',
                            borderRadius: '10px',
                            fontSize: '13px',
                            color: '#f68108',
                            lineHeight: '24px',
                            textAlign: 'center',
                            marginLeft: '10px',
                        }}
                    >
                        还
                    </span>}
                </>
            ),
        },

        {
            title: '领取部门',
            width: 160,
            dataIndex: 'departmentName',
        },
        {
            title: '领取数量',
            width: 160,
            dataIndex: 'totalNum',
        },
        {
            title: '领取金额',
            width: 100,
            dataIndex: 'totalAmount',
        },
        {
            title: '库管员',
            width: 100,
            dataIndex: 'createUser',
        },
        {
            title: '领取时间',
            width: 170,
            dataIndex: 'createTime',
            render: (text) => `${momentFormat(text)}`,
        },
        // {
        //     title: '领用说明',
        //     width: 100,
        //     dataIndex: 'note',
        // }, {
        //     title: '领取人',
        //     width: 180,
        //     dataIndex: 'user',
        // },
        // {
        //     title: '存放地点',
        //     width: 160,
        //     dataIndex: 'deposit',
        // },
        {
            title: '打印次数',
            width: 100,
            dataIndex: 'printingTimes',
        },
    ]

    //点击行选高亮
    const onRow = (id: string) => {
        let findIndex = selectedRowKeys.indexOf(id)
        let newSelectedRowKeys = [...selectedRowKeys]
        if (findIndex === -1) {
            newSelectedRowKeys.push(id)
            setSelectedRowKeys(newSelectedRowKeys)
        } else {
            newSelectedRowKeys.splice(findIndex, 1)
            setSelectedRowKeys(newSelectedRowKeys)
        }
    }

    return (
        <Table
            rowKey={(record) => record.id}
            loading={loading}
            rowSelection={{
                //全部选中时  (存string[])
                onSelectAll: (selected, selectedRows, changeRows) => {
                    let changeRowId = changeRows.map((item) => item.id)
                    selected
                        ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
                        : setSelectedRowKeys((origin) => origin.filter((item) => changeRowId.indexOf(item) < 0))
                },
                onSelect: (record) => onRow(record.id),
                selectedRowKeys: selectedRowKeys,
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ['bottomCenter'],
                showTotal: (total: number) => `共${total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                },
                showSizeChanger: true,
            }}
            bordered
            onRow={(record) => ({
                onClick: () => onRow(record.id),
                onContextMenu: (e) => {
                    e.preventDefault()
                    setSelectedRowKeys([record.id])
                },
            })}
            scroll={{ x: 'max-content', y: 'calc(100vh - 410px)' }}
        />
    )
}
